import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push as Push } from 'redux-first-history';
import { ApplicationState as State } from '@api/store';
import Props from './../InboundRoutesInterface';
import { ShowDialog } from '@api/store/dialog/actions';
import { ShowDialogParams } from '@api/store/dialog/types';
import {
    LoadInboundRoutes,
    SetSingleInbound,
    ValidateInput,
    AddNewInbound,
    CleanSingleInbound,
    DeleteSingleInbound,
    UpdateInbound,
} from '@api/store/inboundRoutes/actions';
import { InboundPayload } from '@dev/ee-api/ee-api-models';
import { SingleInbound as SettingsModule } from '@dev/ee-modules';
import { SettingsPaths } from '@api/services/dictionaries/paths';
const mapState = (state: State, ownProps: Props): Props => {
    return {
        ...ownProps,
        account: state.account,
        browser: state.browser,
        dialog: state.dialog,
        inbound: state.inbound,
    };
};

const dispatchProps = {
    ShowDialog,
    LoadInboundRoutes,
    SetSingleInbound,
    ValidateInput,
    AddNewInbound,
    CleanSingleInbound,
    DeleteSingleInbound,
    UpdateInbound,
    Push,
};

interface DispatchProps {
    ShowDialog(params: ShowDialogParams): void;
    LoadInboundRoutes(): void;
    SetSingleInbound(singleInbound: InboundPayload): void;
    ValidateInput(name: string, value: string, type: 'url' | 'email' | 'string'): void;
    AddNewInbound(inbound: InboundPayload): void;
    CleanSingleInbound(): void;
    DeleteSingleInbound(id: string): void;
    UpdateInbound(id: string, inbound: InboundPayload): void;
    Push(url: string): void;
}

type ExtendedProps = Props & DispatchProps;

class SingleInbound extends Component<ExtendedProps> {
    render(): JSX.Element {
        return <SettingsModule paths={SettingsPaths} {...this.props} />;
    }
}

export default connect<Props, DispatchProps>(mapState, dispatchProps)(SingleInbound);
